import { MouseEvent } from 'react';
import { NavigateFunction } from 'react-router';
import { hasTextSelection } from './has-text-selection';

interface HandlePostCardClickParams {
  event: MouseEvent;
  linkToPost?: boolean;
  navigate: NavigateFunction;
  postPath: string;
}

export function handlePostCardClick({
  event,
  linkToPost,
  navigate,
  postPath,
}: HandlePostCardClickParams): void {
  const isSelecting = hasTextSelection();

  if (!isSelecting && linkToPost) {
    if (event.metaKey || event.ctrlKey) {
      window.open(postPath, '_blank');
    } else {
      navigate(postPath);
    }
  } else if (isSelecting) {
    event.preventDefault();
  }
}
